/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportRefreshYoutubePlaylistsMutationResponse, SocialExportRefreshYoutubePlaylistsPathParams, SocialExportRefreshYoutubePlaylists400, SocialExportRefreshYoutubePlaylists401, SocialExportRefreshYoutubePlaylists403, SocialExportRefreshYoutubePlaylists404 } from "../models/SocialExportRefreshYoutubePlaylists";

export function getSocialExportRefreshYoutubePlaylistsUrl(connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"]) {
  const res = { method: 'POST', url: `/social-export/v1/platforms/youtube/${connectionId}/playlists/refresh` as const }
  return res
}

/**
 * @description Bypasses cache and fetches fresh playlists from the YouTube API, then caches the result.
 * @summary Refresh YouTube playlists for a connection
 * {@link /social-export/v1/platforms/youtube/:connectionId/playlists/refresh}
 */
export async function socialExportRefreshYoutubePlaylists(connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportRefreshYoutubePlaylistsMutationResponse, ResponseErrorConfig<SocialExportRefreshYoutubePlaylists400 | SocialExportRefreshYoutubePlaylists401 | SocialExportRefreshYoutubePlaylists403 | SocialExportRefreshYoutubePlaylists404>, unknown>({ method : "POST", url : getSocialExportRefreshYoutubePlaylistsUrl(connectionId).url.toString(), ... requestConfig })
  return res.data
}